import { t, TranslationKey } from './i18n';

export function getLabelForSensorType(sensor_type: string) {
  return t(`common.commonSensors.${sensor_type}` as TranslationKey);
}
